var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
import React, { Fragment } from "react";
import classnames from "classnames";
import { Heading } from "@riseart/common";
import { sectionContentCls, sectionContentTitleCls, sectionContentTitleFlexCls, sectionContentTitleFlexMainCls, sectionContentTitleFlexLinkCls, sectionContentBodyCls, sectionContentSubtitleCls } from "./Content.less";
var SectionContent = /* @__PURE__ */ __name(function SectionContent2(_ref) {
  var _ref$nodeType = _ref.nodeType, ComponentType = _ref$nodeType === void 0 ? "div" : _ref$nodeType, title = _ref.title, _ref$subTitle = _ref.subTitle, subTitle = _ref$subTitle === void 0 ? null : _ref$subTitle, _ref$headingProps = _ref.headingProps, headingProps = _ref$headingProps === void 0 ? {} : _ref$headingProps, _ref$headingSubTitleP = _ref.headingSubTitleProps, headingSubTitleProps = _ref$headingSubTitleP === void 0 ? {} : _ref$headingSubTitleP, _ref$contentProps = _ref.contentProps, contentProps = _ref$contentProps === void 0 ? {} : _ref$contentProps, _ref$link = _ref.link, link = _ref$link === void 0 ? null : _ref$link, className = _ref.className, children = _ref.children;
  var headingTitle = typeof title === "string" || title && _typeof(title) === "object" && title.type !== React.Fragment ? /* @__PURE__ */ React.createElement(Heading, _extends({
    tag: "h3",
    level: "3",
    noMargin: !!subTitle
  }, headingProps), title) : title;
  var headingSubTitle = typeof subTitle === "string" || subTitle && _typeof(subTitle) === "object" && subTitle.type !== React.Fragment ? /* @__PURE__ */ React.createElement(Heading, _extends({
    tag: "h4",
    level: "5"
  }, headingSubTitleProps, {
    className: classnames(sectionContentSubtitleCls, headingSubTitleProps && headingSubTitleProps.className)
  }), subTitle) : null;
  var heading = headingTitle && headingSubTitle ? /* @__PURE__ */ React.createElement(Fragment, null, headingTitle, headingSubTitle) : headingTitle;
  return /* @__PURE__ */ React.createElement(ComponentType, {
    className: classnames(sectionContentCls, className)
  }, (title || subTitle || link) && /* @__PURE__ */ React.createElement("div", {
    className: classnames(sectionContentTitleCls, link && sectionContentTitleFlexCls)
  }, link ? /* @__PURE__ */ React.createElement("div", {
    className: sectionContentTitleFlexMainCls
  }, heading) : heading, link ? /* @__PURE__ */ React.createElement("div", {
    className: sectionContentTitleFlexLinkCls
  }, link) : null), /* @__PURE__ */ React.createElement("div", _extends({
    className: sectionContentBodyCls
  }, contentProps), children));
}, "SectionContent");
export {
  SectionContent
};
